import { StorageZap } from "../useQueryStorageZaps";

export function getUserIdsFromStorageZaps(zaps: StorageZap[]): number[] {
  const userIdSet = zaps.reduce((accumulator, zap) => {
    accumulator.add(zap.customuserId);
    return accumulator;
  }, new Set<number>());

  return [...userIdSet];
}
